import { jsx as i } from "react/jsx-runtime";
import "react";
import o from "../node_modules/react-transition-group/esm/CSSTransition.es.js";
const s = ({
  children: t,
  in: r,
  nodeRef: n,
  ...e
}) => /* @__PURE__ */ i(
  o,
  {
    in: r,
    timeout: 300,
    classNames: {
      enter: (
        /* tw: */
        "rcl--opacity-0 rcl--pointer-events-none rcl--touch-none"
      ),
      enterActive: (
        /* tw: */
        "rcl--opacity-100 rcl--transition-opacity rcl--duration-300 rcl--ease-in"
      ),
      enterDone: (
        /* tw: */
        "rcl--opacity-100"
      ),
      exitActive: (
        /* tw: */
        "rcl--opacity-0 rcl--transition-opacity rcl--duration-300 rcl--ease-in"
      ),
      exitDone: (
        /* tw: */
        "rcl--opacity-0 rcl--pointer-events-none rcl--touch-none"
      )
    },
    nodeRef: n,
    ...e,
    children: t
  }
);
export {
  s as default
};
//# sourceMappingURL=FadeTransition.es.js.map
